<footer class="desktopResponsive">
    <div class="footerContent">
        <div class="row py-5">
            <div class="col-md-3">
                <div class="footer_left">
                    <div class="footerLogo" routerLink=""></div>
                    <div class="detailsContent">
                        <div class="zeeLearnText mt-4">Zee Learn Limited </div>
                        <div class="adress mt-2">135, Continental Building,B wing, Worli, Mumbai,Maharashtra 400 018.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-9">
                <div class="footerTextContnetn">
                    <div class="subListContent">
                        <div class="row">
                            <div class="col-md-3">
                                <ul>
                                    <li routerLink="/playgroup">PlayGroup</li>
                                    <li routerLink="/nursery">Nursery</li>
                                    <li routerLink="/kindergarten">Kindergarten</li>
                                    <li routerLink="/teacher-training-programme">Teacher Training Programme</li>
                                    <li routerLink="/privacy-policy">Privacy Policy</li>
                                    <li routerLink="/elementary-school">Elementary School</li>
                                </ul>
                            </div>
                            <div class="col-md-2">
                                <ul>
                                    <li routerLink="/daycare">DayCare</li>
                                    <li routerLink="/pentemind">Péntemind</li>
                                    <li routerLink="/blog">Blog</li>
                                     <li routerLink="/innews">In News</li>
                                    <li routerLink="/locateus">Locate Us</li>
                                    <li routerLink="/our-presence">Our Presence</li>
                                    </ul>
                            </div>
                            <div class="col-md-3">
                               <div class="youtube_video">
                                <div onclick="vtIframeEnquiry(this, 'https://www.youtube.com/embed/f0-9CI97fCY', 10)" class="testimonial_profile_img" data-form="lg" data-title="Site Video" data-btn="Continue Tour" data-enquiry="Zica Site Tour" data-redirect="virtualtour" data-toggle="modal" data-target="#enqModal">
                                    <iframe frameborder="0" class="d-video" allowfullscreen="" sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation" src="https://www.youtube.com/embed/f0-9CI97fCY?autoplay=1&amp;rel=0&amp;controls=0&amp;"
                                            width="100%"></iframe>
                                </div>
                               </div>
                            </div>
                            <div class="col-md-4">
                                <ul class="ul_content">
                                    <li>Contact US</li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <a href="tel:91 93200 63100" class="d-flex"><i class="fa fa-phone"></i><span class="details_text"> +91 93200 63100</span></a>
                                        </div>
                                    </li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <i class="fa fa-envelope"></i><span class="details_text">care&#64;kidzee.com</span>
                                        </div>
                                    </li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <i class="fa fa-clock-o"></i><span class="details_text"> 10:00 a.m. to 06:00
                                                p.m., Mon-Fri</span>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="text-white text-center footerTextEmailId">
                    Copyright © Zee Learn Ltd. All rights reserved.
                </div>
            </div>
        </div>
    </div>
    <div class="btn_header" id="footer_btn">
        <div class="btn_content">
            <div class="fb_insta_icon_content">

             <a href="https://www.facebook.com/KidzeeIndia" target="_blank"> <i class="fa fa-facebook media_icon"></i></a>
             <a href="https://www.instagram.com/kidzeeindia/" target="_blank">
                <i class="fa fa-instagram media_icon"></i>
                <!-- <i class="fa fa-instagram"></i> -->
            </a>
            </div>
            <div class="btn_div d-flex">
                <div class="d-flex justify-content-center align-items-center  px-2">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/admission_icon.png" width="25px" height="30px" alt="">
            <button class="white_btn brder_right" routerLink="/admissions">Admission Enquiry</button>
        </div>
        <div class="d-flex justify-content-center align-items-center px-2">
            <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/start_icon.png" width="25px" height="30px" alt="">
            <button class="white_btn" routerLink="/partner-with-kidzee">Start a Franchise</button>
        </div>
        </div>
        </div>

    </div>
    <a href="#" class="scrollToTop" id="scroll_Top_btn">
        <button class="btn scroll_btn"><i class="fa fa-chevron-up"></i></button></a>
</footer>

<footer class="mobileResponsive">
    <div class="footerContent">
        <div class="row">
            <div class="col-md-4">
                <div class="footer_left">
                    <div class="footerLogo"></div>
                    <div class="detailsContent">
                        <div class="zeeLearnText mt-3">Zee Learn Limited </div>
                        <div class="adress mt-2">135, Continental Building,B wing, Worli, Mumbai,Maharashtra 400 018.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-8">
                <div class="footerTextContnetn">
                    <hr>
                    <div class="subListContent">
                        <div class="row">
                            <div class="col-md-4">
                                <ul>
                                    <li routerLink="/playgroup">PlayGroup</li>
                                    <li routerLink="/nursery">Nursery</li>
                                    <li routerLink="/kindergarten">Kindergarten</li>
                                    <li routerLink="/teacher-training-programme">Teacher Training Programme</li>
                                    <li routerLink="/privacy-policy">Privacy Policy</li>
                                    <li routerLink="/elementary-school">Elementary School</li>
                                </ul>
                            </div>
                            <hr>
                            <div class="col-md-4">
                                <ul>
                                    <li routerLink="/daycares">DayCare</li>
                                    <li routerLink="/pentemind">Péntemind</li>
                                     <li routerLink="/blog">Blog</li>
                                     <li routerLink="/innews">In News</li>
                                    <li routerLink="locateus">Locate Us</li>
                                   </ul>
                            </div>
                            <div class="col-12">
                                <div class="youtube_video">
                                    <div onclick="vtIframeEnquiry(this, 'https://www.youtube.com/embed/f0-9CI97fCY', 10)" class="testimonial_profile_img" data-form="lg" data-title="Site Video" data-btn="Continue Tour" data-enquiry="Zica Site Tour" data-redirect="virtualtour" data-toggle="modal" data-target="#enqModal">
                                        <iframe frameborder="0" class="d-video" allowfullscreen="" sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation" src="https://www.youtube.com/embed/f0-9CI97fCY?autoplay=1&amp;rel=0&amp;controls=0&amp;"
                                                width="100%"></iframe>
                                    </div>
                                   </div>
                            </div>
                            <hr>
                            <div class="col-md-4">
                                <ul class="ul_content">
                                    <li>Contact US</li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <a href="tel:91 93200 63100" class="d-flex"><i class="fa fa-phone"></i><span class="details_text"> +91 93200 63100</span></a>
                                        </div>
                                    </li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <i class="fa fa-phone"></i><span class="details_text">
                                                care&#64;kidzee.com</span>
                                        </div>
                                    </li>
                                    <li class="mt-2">
                                        <div class="icon_content">
                                            <i class="fa fa-clock"></i><span class="details_text"> 10:00 a.m. to 06:00
                                                p.m., Mon-Fri</span>
                                        </div>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="text-white text-center footerTextEmailId">
                    Copyright © Zee Learn Ltd. All rights reserved.
                </div>
            </div>
            <div class="col-dm-12">
                <div class="fb_insta_icon_content">
                    <div class="btn_div d-flex">
                        <div class="d-flex justify-content-center align-items-center  px-2">
                        <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/admission_icon.png" width="25px" height="30px" alt="">
                    <button class="white_btn brder_right" routerLink="/admissions">Admission Enquiry</button>
                </div>
                <div class="d-flex justify-content-center align-items-center px-2">
                    <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/img/new-kidzee/start_icon.png" width="25px" height="30px" alt="">
                    <button class="white_btn" routerLink="/partner-with-kidzee">Start a Franchise</button>
                </div>
                </div>
                </div>
            </div>
        </div>
    </div>
    <div class="btn_header" id="footer_btn1">
    </div>

    <a href="#" class="scrollToTop" id="scroll_Top_btn">
        <button class="btn scroll_btn"><i class="fa fa-chevron-up"></i></button></a>
</footer>
